﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.filter:HomeController
 * @description
 * # HomeController
 * Controller of the ntmApp
 */

/*jshint sub:true*/
angular.module('ntmApp')
  .filter('commaSeparatedNumber', ['$filter', function ($filter) {

      return function (input) {

          if (angular.isNumber(input)) {

              return $filter('number')(input);
          }

          return input;
      };
  }]);